export class FurnishingTags {
  public static readonly NotSet = "Do Not Replace";

  public static readonly Cull = "To Be Removed";

  public static readonly AirConditioner = "Air Conditioner";
  public static readonly Artwork1 = "Artwork1";
  public static readonly Artwork2 = "Artwork2";
  public static readonly Artwork3 = "Artwork3";
  public static readonly Artwork4 = "Artwork4";
  public static readonly Artwork5 = "Artwork5";
  public static readonly Artwork6 = "Artwork6";
  public static readonly Artwork7 = "Artwork7";
  public static readonly Artwork8 = "Artwork8";
  public static readonly Artwork9 = "Artwork9";
  public static readonly Artwork10 = "Artwork10";
  public static readonly Artwork11 = "Artwork11";
  public static readonly Artwork12 = "Artwork12";
  public static readonly ArtworkSmall = "Artwork Small";
  public static readonly ArtworkMedium = "Artwork Medium";
  public static readonly ArtworkLarge = "Artwork Large";
  public static readonly ArtworkLandscapeSmall = "Artwork Landscape Small";
  public static readonly ArtworkLandscapeMedium = "Artwork Landscape Medium";
  public static readonly ArtworkLandscapeLarge = "Artwork Landscape Large";
  public static readonly ArtworkPortraitSmall = "Artwork Portrait Small";
  public static readonly ArtworkPortraitMedium = "Artwork Portrait Medium";
  public static readonly ArtworkPortraitLarge = "Artwork Portrait Large";
  public static readonly BarStool = "Bar Stool";
  public static readonly BathMat = "Bath Mat";
  public static readonly Bicycle = "Bicycle";
  public static readonly Bookcase = "Bookcase";
  public static readonly Cabinet = "Cabinet";
  public static readonly ChairDesk = "Chair Desk";
  public static readonly ChairDining = "Chair Dining";
  public static readonly ClothingHanging1 = "Clothing Hanging 1";
  public static readonly ClothingHanging2 = "Clothing Hanging 2";
  public static readonly ClothingHanging3 = "Clothing Hanging 3";
  public static readonly CoffeeTableAccoutrements = "Coffee Table Accoutrements";
  public static readonly CouchSingle = "Couch Single";
  public static readonly CouchDouble = "Couch Double";
  public static readonly CouchLShapeLeft = "Couch L-Shape Left";
  public static readonly CouchLShapeRight = "Couch L-Shape Right";
  public static readonly Couch1Seat = "Couch 1 Seat";
  public static readonly Couch2Seat = "Couch 2 Seat";
  public static readonly Couch3Seat = "Couch 3 Seat";
  public static readonly Couch2x3Seat = "Couch 2x3 Seat";
  public static readonly Couch3x2Seat = "Couch 3x2 Seat";
  public static readonly Couch3x3Seat = "Couch 3x3 Seat";
  public static readonly Couch3x4Seat = "Couch 3x4 Seat";
  public static readonly Couch4x3Seat = "Couch 4x3 Seat";
  public static readonly Credenza = "Credenza";
  public static readonly Crib = "Crib";
  public static readonly Desk = "Desk";
  public static readonly Dresser = "Dresser";
  public static readonly DresserAccoutrements = "Dresser Accoutrements";
  public static readonly ExerciseBike = "Exercise Bike";
  public static readonly FloorLamp = "Floor Lamp";
  public static readonly LightPendant = "Light Pendant";
  public static readonly Mirror = "Mirror";
  public static readonly Plant = "Plant";
  public static readonly Plant1 = "Plant 1";
  public static readonly Plant2 = "Plant 2";
  public static readonly Plant3 = "Plant 3";
  public static readonly RugSmall = "Rug Small";
  public static readonly RugMedium = "Rug Medium";
  public static readonly RugLarge = "Rug Large";
  public static readonly SmallKitchenApplianceKettle = "Small Kitchen Appliance Kettle";
  public static readonly SmallKitchenApplianceToaster = "Small Kitchen Appliance Toaster";
  public static readonly TableBedside = "Table Bedside";
  public static readonly TableBedsideLeft = "Table Bedside Left";
  public static readonly TableBedsideRight = "Table Bedside Right";
  public static readonly TableCenterpiece = "Table Centerpiece";
  public static readonly TableCoffee = "Table Coffee";
  public static readonly TableDining = "Table Dining";
  public static readonly TableOutdoor = "Table Outdoor";
  public static readonly TableOutdoorTwoSeat = "Table Outdoor Two Seat";
  public static readonly TableOutdoorFourSeat = "Table Outdoor Four Seat";
  public static readonly Treadmill = "Treadmill";
  public static readonly WallProp = "Wall Prop";//items that lean against a wall (typically)

  public static readonly BlindLeftWithPelmet = "Blind Left With Pelmet";
  public static readonly BlindRightWithPelmet = "Blind Right With Pelmet";
  public static readonly BlindLeftWithPelmetFeature = "Blind Left With Pelmet Feature";
  public static readonly BlindRightWithPelmetFeature = "Blind Right With Pelmet Feature";
  public static readonly BlindPelmetExtension = "Blind Pelmet Extension";
  public static readonly BlindPelmetExtensionFeature = "Blind Pelmet Extension Feature";
  public static readonly BlindPelmetEndCapLeft = "Blind Pelmet End Cap Left";
  public static readonly BlindPelmetEndCapLeftFeature = "Blind Pelmet End Cap Left Feature";
  public static readonly BlindPelmetEndCapRight = "Blind Pelmet End Cap Right";
  public static readonly BlindPelmetEndCapRightFeature = "Blind Pelmet End Cap Right Feature";
  public static readonly CurtainLeftWithPelmet = "Curtain Left With Pelmet";
  public static readonly CurtainRightWithPelmet = "Curtain Right With Pelmet";
  public static readonly CurtainLeftWithPelmetFeature = "Curtain Left With Pelmet Feature";
  public static readonly CurtainRightWithPelmetFeature = "Curtain Right With Pelmet Feature";
  public static readonly CurtainPelmetExtension = "Curtain Pelmet Extension";
  public static readonly CurtainPelmetExtensionFeature = "Curtain Pelmet Extension Feature";
  public static readonly CurtainPelmetEndCapLeft = "Curtain Pelmet End Cap Left";
  public static readonly CurtainPelmetEndCapLeftFeature = "Curtain Pelmet End Cap Left Feature";
  public static readonly CurtainPelmetEndCapRight = "Curtain Pelmet End Cap Right";
  public static readonly CurtainPelmetEndCapRightFeature = "Curtain Pelmet End Cap Right Feature";

  public static readonly Dishwasher = "Dishwasher";
  public static readonly Dryer = "Dryer";
  public static readonly Microwave = "Microwave";
  public static readonly WashingMachine = "Washing Machine";

  public static readonly BedSingle = "Bed Single";
  public static readonly BedDouble = "Bed Double";
  public static readonly BedQueen = "Bed Queen";
  public static readonly BedKing = "Bed King";
  public static readonly BedBunk = "Bunk Bed";

  public static readonly Fridge = "Fridge";
  public static readonly FridgeSingleDoor = "Fridge Single Door";
  public static readonly FridgeDoubleDoor = "Fridge Double Door";
  public static readonly FridgeBar = "Fridge (Bar)";

  public static readonly TV = "TV";
  public static readonly TVStand = "TV Stand";
  public static readonly TVWallMounted = "TV Wall Mounted";

  public static readonly BathFreestanding = "Bath Free Standing";
  public static readonly BathWithoutHob = "Bath Without Hob";
  public static readonly ToiletWallMounted = "Toilet Wall Mounted";
  public static readonly ToiletFloorMounted = "Toilet Floor Mounted";
  public static readonly ToiletRollHolder = "Toilet Roll Holder";
  public static readonly ToiletAccessories = "Toilet Accessories";
  public static readonly BathMixer = "Bath Mixer";
  public static readonly WallMixer = "Wall Mixer";
  public static readonly SinkMixer = "Sink Mixer";
  public static readonly ShowerMixer = "Shower Mixer";
  public static readonly VanityMixer = "Vanity Mixer";

  public static readonly BathSpout = "Bath Spout";
  public static readonly RobeHook = "Robe Hook";
  public static readonly TowelRail = "Towel Rail";
  public static readonly TowelRing = "Towel Ring";
  public static readonly ShowerBase = "Shower Base";
  public static readonly ShowerBaseMoulded = "Shower Base Moulded";
  public static readonly ShowerRose = "Shower Rose";
  public static readonly ShowerHeadOnRail = "Shower Head on Rail";
  public static readonly VanityBasin = "Vanity Basin";
  public static readonly VanityBasinInset = "Vanity Basin Inset";
  public static readonly VanityBasinAboveCounter = "Vanity Basin Above Counter";
  public static readonly VanityFaucet = "Vanity Faucet";

  public static readonly LaundryTaps = "Laundry Taps";
  public static readonly LaundryTrough = "Laundry Trough";

  public static readonly SinkSingleBowlInsetSink = "Sink Single Bowl Inset";
  public static readonly SinkDoubleBowlInsetSink = "Sink Double Bowl Inset";
  public static readonly SinkSingleBowlUndermountSink = "Sink Single Bowl Undermount";
  public static readonly SinkDoubleBowlUndermountSink = "Sink Double Bowl Undermount";
  public static readonly SinkSingleBowlLeftHandDraining = "Sink Single Bowl Left Hand Draining";
  public static readonly SinkSingleBowlRightHandDraining = "Sink Single Bowl Right Hand Draining";
  public static readonly SinkDoubleBowlLeftHandDraining = "Sink Double Bowl Left Hand Draining";
  public static readonly SinkDoubleBowlRightHandDraining = "Sink Double Bowl Right Hand Draining";

  public static readonly Oven540mmFreeStanding = "Oven 540mm Free Standing";
  public static readonly Oven600mmFreeStanding = "Oven 600mm Free Standing";
  public static readonly Oven900mmFreeStanding = "Oven 900mm Free Standing";
  public static readonly Oven600mmUnderbench = "Oven 600mm Underbench";
  public static readonly Oven900mmUnderbench = "Oven 900mm Underbench";
  
  public static readonly RangeHood600mm = "Range Hood 600mm";
  public static readonly RangeHood900mm = "Range Hood 900mm";
  public static readonly RangeHoodIntegrated900mm = "Range Hood Integrated 900mm";
  public static readonly RangeHoodSlideout900mm = "Range Hood Slideout 900mm";
  public static readonly RangeHoodUndermount900mm = "Range Hood Undermount 900mm";
  public static readonly RangeHoodCanopy900mm = "Range Hood Canopy 900mm";

  public static readonly Cooktop600mm = "Cooktop 600mm";
  public static readonly Cooktop900mm = "Cooktop 900mm";
  public static readonly Microwave600mmBuiltin = "Microwave 600mm Builtin";
  public static readonly Microwave900mmBuiltin = "Microwave 900mm Builtin";
  public static readonly CoffeeMachine600mmBuiltin = "Coffee Machine 600mm Builtin";

  public static readonly DoorHandle = "Door Handle";
  public static readonly DoorHandleExternal = "Door Handle External";
  public static readonly DoorHandleExternalLeftHand = "Door Handle External Left Hand";
  public static readonly DoorHandleExternalRightHand = "Door Handle External Right Hand";
  public static readonly DoorHandleInternal = "Door Handle Internal";

  public static readonly DoorExternalSwingRightHand = "Door External Swing Right Handed";
  public static readonly DoorExternalSwingLeftHand = "Door External Swing Left Handed";
  public static readonly DoorExternalSlidingRightHand = "Door External Sliding Right Handed";
  public static readonly DoorExternalSlidingLeftHand = "Door External Sliding Left Handed";
  public static readonly DoorFrontSwingRightHand = "Door Front Swing Right Handed";
  public static readonly DoorFrontSwingLeftHand = "Door Front Swing Left Handed";
  public static readonly DoorInternalSwingRightHand = "Door Internal Swing Right Handed";
  public static readonly DoorInternalSwingLeftHand = "Door Internal Swing Left Handed";
  public static readonly DoorInternalSlidingRightHand = "Door Internal Sliding Right Handed";
  public static readonly DoorInternalSlidingLeftHand = "Door Internal Sliding Left Handed";
  public static readonly DoorGarageSingle = "Door Garage Single";
  public static readonly DoorGarageDouble = "Door Garage Double";
};
